import { render, staticRenderFns } from "./render.vue?vue&type=template&id=4a0b3d3c&scoped=true"
import script from "./render.vue?vue&type=script&lang=js"
export * from "./render.vue?vue&type=script&lang=js"
import style0 from "./render.vue?vue&type=style&index=0&id=4a0b3d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0b3d3c",
  null
  
)

export default component.exports